"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.write = exports.writeAbsolute = exports.getSprite = void 0;
var rogueColors_1 = require("@dive/colors/rogueColors");
var mathUtils_1 = require("@lib/mathUtils");
var common_sidecar_1 = require("@main/common-sidecar");
var rogueGlyphs_1 = require("./rogueGlyphs");
var rogueGlyphs_sidecar_1 = require("./rogueGlyphs-sidecar");
var rogueMonofont_fontMap_1 = require("./rogueMonofont_fontMap");
var rogueMonofont_letterSizeMap_1 = require("./rogueMonofont_letterSizeMap");
var rogueMonofont_scales_1 = require("./rogueMonofont_scales");
// const spriteBack = sprites.monofont72
var _idx = 0;
var getSprite = function (c) {
    return rogueMonofont_fontMap_1.fontMap[c] || rogueMonofont_fontMap_1.fontMap._default;
};
exports.getSprite = getSprite;
// export const drawBackground = (
//   x: number,
//   y: number,
//   colorBack: number,
//   liveFor = 0,
// ) => {
//   if (colorBack !== rogueColors.none) {
//     rogueGlyphs.writeBg(x, y, colorBack, spriteBack, liveFor)
//   }
// }
var writeAbsolute = function (x, y, text, scale, color) {
    if (scale === void 0) { scale = 1; }
    if (color === void 0) { color = rogueColors_1.rogueColors.light; }
    x /= rogueGlyphs_1.rogueDef.sizeX;
    y /= rogueGlyphs_1.rogueDef.sizeY;
    return exports.write(x, y, text, scale, color, null, null, null, '', 0);
};
exports.writeAbsolute = writeAbsolute;
var write = function (x, y, text, scale, color, 
// colorBack = rogueColors.none,
onClick, onHover, hotkey, effect, liveFor, isMonoFont) {
    if (color === void 0) { color = rogueColors_1.rogueColors.light; }
    if (onClick === void 0) { onClick = null; }
    if (onHover === void 0) { onHover = null; }
    if (hotkey === void 0) { hotkey = null; }
    if (effect === void 0) { effect = ''; }
    if (liveFor === void 0) { liveFor = 0; }
    if (isMonoFont === void 0) { isMonoFont = false; }
    var isWave = effect === 'wave';
    var isRainbow = effect === 'rainbow';
    var isFire = effect === 'fire';
    var isWater = effect === 'water';
    if (effect === 'rainbowwave') {
        isWave = true;
        isRainbow = true;
    }
    var elapsed = common_sidecar_1.common.getElapsedTime();
    var adjustX = 0;
    var adjustY = 0;
    // if (colorBack !== rogueColors.none) {
    //   // TODO: restore this button functionality
    //   // if (rogueMouseAreas.isOver(x, y, text.length, 1)) {
    //   //   colorBack = rogueColors.lightBlue
    //   // }
    // }
    var ox = 0;
    var defaultSize = rogueMonofont_letterSizeMap_1.letterSizeMap._default;
    for (var i = 0; i < text.length; i++) {
        var size = isMonoFont ? [1, 0] : rogueMonofont_letterSizeMap_1.letterSizeMap[text[i]] || defaultSize;
        var xSize = size[0] / 2;
        var xLeading = xSize * size[1];
        var xTrailing = xSize - xLeading;
        ox += xLeading * scale;
        // if (colorBack !== rogueColors.none) {
        //   drawBackground(x + ox, y, colorBack, liveFor)
        // }
        // let c = rogueGlyphs.create()
        // c.scale = scale
        var yo = 0;
        var ch = text[i];
        var famkey = ch;
        if (rogueMonofont_fontMap_1.fontAdjustMap[famkey]) {
            // console.log('adjust', famkey, fontAdjustMap[famkey])
            adjustX = (rogueMonofont_fontMap_1.fontAdjustMap[famkey][0] * 1) / 8;
            adjustY = (rogueMonofont_fontMap_1.fontAdjustMap[famkey][1] * 1) / 8;
        }
        else {
            adjustX = 0;
            adjustY = 0;
        }
        if (isWave) {
            yo = Math.sin(elapsed * 4 + 0.5 * (x + ox + y)) * 0.2;
        }
        if (isRainbow) {
            color =
                rogueMonofont_scales_1.rainbowScale[mathUtils_1.betterMod(x + ox + y - Math.floor(elapsed / 0.1), rogueMonofont_scales_1.rainbowScale.length)];
        }
        if (isFire) {
            color =
                rogueMonofont_scales_1.fireScale[mathUtils_1.betterMod(x + ox + y - Math.floor(elapsed / 0.1), rogueMonofont_scales_1.fireScale.length)];
        }
        if (isWater) {
            color =
                rogueMonofont_scales_1.waterScale[mathUtils_1.betterMod(x + ox + y - Math.floor(elapsed / 0.1), rogueMonofont_scales_1.waterScale.length)];
        }
        rogueGlyphs_sidecar_1.rogueGlyphs.write(x + ox + adjustX * scale, y + yo + adjustY * scale, text[i], color, liveFor, scale);
        // rogueGlyphs.setPos(c, x + i, y + yo)
        // c.char = text[i]
        // // Update sprite
        // spritesUtil.setPackedFrameSameScale(c.image, getSprite(c.char)[0])
        // c.image.tint = color
        // c.visible = true
        ox += xTrailing * scale;
    }
    if (onClick) {
        // const onHover = () => {
        //   console.log('hover', text)
        //   write(x + 1, y, text, color, rogueColors.lightBlue)
        // }
        // TODO: restore this button functionality
        // rogueMouseAreas.create(x, y, text.length, 1, onHover, onClick)
        // if (hotkey) {
        //   rogueHotkeys.create(hotkey, onClick)
        // }
    }
    return text.length;
};
exports.write = write;
// interface IChunk {
//   text: string
//   x: number
//   y: number
//   color: number
//   effect: string
// }
// export const measureWrapped = (width: number, text: string) => {
//   return writeWrapped(
//     0,
//     0,
//     width,
//     text,
//     rogueColors.none,
//     rogueColors.none,
//     9999,
//     true,
//   )
// }
// export const writeWrapped = (
//   x: number,
//   y: number,
//   width: number,
//   text: string,
//   color = rogueColors.light,
//   colorBack = rogueColors.none,
//   elapsed: number = 9999,
//   measureOnly: boolean = false,
// ) => {
//   let colorStack = []
//   let effect = ''
//   let xs = x
//   let xe = x + width - 1
//   let ys = y
//   // get chunks
//   let chunks: IChunk[] = []
//   let chunk = ''
//   const addChunk = () => {
//     let len = chunk.length
//     if (chunk) {
//       chunks.push({
//         text: chunk,
//         x,
//         color,
//         y,
//         effect,
//       })
//       chunk = ''
//     }
//     return len
//   }
//   let isInCommandReadMode = false
//   let changedColor = false
//   let command = ''
//   for (let i = 0; i < text.length; i++) {
//     let c = text[i]
//     if (isInCommandReadMode) {
//       if (c === '|') {
//         isInCommandReadMode = false
//         if (command.startsWith('color:')) {
//           let colorText = command.substring('color:'.length)
//           let num = parseInt(colorText)
//           colorStack.push(color)
//           changedColor = true
//           color = num
//         } else if (command === 'red') {
//           colorStack.push(color)
//           changedColor = true
//           color = rogueColors.red
//         } else if (command === 'yellow') {
//           colorStack.push(color)
//           changedColor = true
//           color = rogueColors.yellow
//         } else if (command === 'orange') {
//           colorStack.push(color)
//           changedColor = true
//           color = rogueColors.orange
//         } else if (command === 'green') {
//           colorStack.push(color)
//           changedColor = true
//           color = rogueColors.green
//         } else if (command === 'lightBlue') {
//           colorStack.push(color)
//           changedColor = true
//           color = rogueColors.lightBlue
//         } else if (command === 'black') {
//           colorStack.push(color)
//           changedColor = true
//           color = rogueColors.pureBlack
//         } else if (command === 'dark') {
//           colorStack.push(color)
//           changedColor = true
//           color = rogueColors.dark
//         } else if (command === 'wave') {
//           effect = 'wave'
//         } else if (command === 'water') {
//           effect = 'water'
//         } else if (command === 'rainbow') {
//           effect = 'rainbow'
//         } else if (command === 'fire') {
//           effect = 'fire'
//         } else if (command === 'rainbowwave') {
//           effect = 'rainbowwave'
//         } else {
//           console.warn('Unknown text formatting command', command)
//         }
//         continue
//       }
//       if (c === ']') {
//         isInCommandReadMode = false // end early?
//         continue
//       } else {
//         command += c
//         continue
//       }
//     }
//     if (c === '[') {
//       // Start reading command
//       x += addChunk()
//       isInCommandReadMode = true
//       command = ''
//       continue
//     }
//     if (c === ']') {
//       // Pop color / effect and end chunk
//       x += addChunk()
//       if (changedColor) {
//         color = colorStack.pop() || rogueColors.light
//         changedColor = false
//       }
//       effect = ''
//       continue
//     }
//     if (c === ' ' || c === '\n' || c === '\r') {
//       x += addChunk() + 1
//       if (c === '\n') {
//         y++
//         x = xs
//       }
//     } else {
//       chunk += c
//     }
//     // Newline detection
//     if (x + chunk.length > xe + 1) {
//       if (x === xs) {
//         addChunk()
//       }
//       x = xs
//       y++
//     }
//   }
//   addChunk()
//   let ye = y
//   let maxBack = elapsed / 0.002
//   let idxBack = 0
//   if (colorBack !== rogueColors.none) {
//     for (let j = ys; j <= ye; j++) {
//       for (let i = xs; i <= xe; i++) {
//         idxBack++
//         if (idxBack > maxBack) {
//           break
//         }
//         drawBackground(i, j, colorBack)
//       }
//       if (idxBack > maxBack) {
//         break
//       }
//     }
//   }
//   let maxChars = elapsed / 0.02 //0.0125
//   let idxChars = 0
//   if (!measureOnly) {
//     chunks.forEach((c) => {
//       if (idxChars > maxChars) {
//         return false
//       }
//       idxChars += c.text.length
//       if (idxChars > maxChars) {
//         let remaining = maxChars - idxChars + c.text.length
//         let remainingText = c.text.substring(0, remaining)
//         if (remainingText) {
//           write(
//             c.x,
//             c.y,
//             remainingText,
//             c.color,
//             rogueColors.none,
//             null,
//             null,
//             null,
//             c.effect,
//           )
//         }
//         return false
//       } else {
//         write(
//           c.x,
//           c.y,
//           c.text,
//           c.color,
//           rogueColors.none,
//           null,
//           null,
//           null,
//           c.effect,
//         )
//       }
//     })
//   }
//   let w = xe - xs + 1
//   let h = ye - ys + 1 + 1
//   return { w, h }
// }
// // export const drawAll = () => {
// //   objs.forEach((c) => {
// //     c.image.x = c.x * rogueDef.sizeX
// //     c.image.y = c.y * rogueDef.sizeY
// //     c.image.visible = c.visible
// //     c.visible = false // reset
// //   })
// //   _idx = 0
// // }
